import { render, staticRenderFns } from "./NewQuestion.vue?vue&type=template&id=c97131fa&scoped=true&"
import script from "./NewQuestion.vue?vue&type=script&lang=js&"
export * from "./NewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./NewQuestion.vue?vue&type=style&index=0&id=c97131fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97131fa",
  null
  
)

export default component.exports